
import { defineComponent, inject, ref } from "vue";
import { getPersonalInfo } from "@/api/http";
const personalInfo = [
    {
        name: "登录帐号",
        key: "name",
    },
    {
        name: "姓名",
        key: "nickname",
    },
    {
        name: "手机",
        key: "phone",
    },
    {
        name: "QQ",
        key: "qq",
    },
    {
        name: "微信",
        key: "wechat",
    },
    {
        name: "入职日期",
        key: "entry_time",
    },
];
export default defineComponent({
    name: "Personal",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["个人信息"]);
        let personalData = ref({});
        getPersonalInfo().then((res: any) => {
            personalData.value = res?.content?.list;
        });
        return {
            personalInfo,
            personalData,
        };
    },
});
